import { render } from "./HomeButton.vue?vue&type=template&id=266217de&scoped=true"
import script from "./HomeButton.vue?vue&type=script&lang=js"
export * from "./HomeButton.vue?vue&type=script&lang=js"

import "./HomeButton.vue?vue&type=style&index=0&id=266217de&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266217de"]])

export default __exports__